export default __webpack_public_path__ + "static/media/WMTCM.f9036a84.svg";